import moment from 'moment'
import { toRefs } from '@vue/composition-api'
import { useVuelidate } from '@vuelidate/core'
import FormDate from './FormDate'
import { mapGetters } from 'vuex'
import _isEqual from 'lodash/isEqual'

export default {
  extends: FormDate,
  name: 'FormEffectiveStartDate',
  props: {
    formValue: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props) {
    const { value, formValue } = toRefs(props)

    const $v = useVuelidate({
      effectiveStartDate: {
        isSameOrBeforeDate: {
          $validator: (v) => !v || !formValue.value.effectiveEndDate || moment(v).isSameOrBefore(moment(formValue.value.effectiveEndDate)),
          $message: () => `Effective start date should be before effective end date (${moment(formValue.value.effectiveEndDate).format('ll')})`,
          $params: {
            effectiveStartDate: value,
            effectiveEndDate: formValue.value.effectiveEndDate,
          },
        },
      },
    }, { effectiveStartDate: value })

    return { $v }
  },
  computed: {
    ...mapGetters([ 'termById' ]),
  },
  watch: {
    'formValue.startTerm' (term, previousTerm) {
      if (_isEqual(term, previousTerm)) return
      // NOTE: this requires the additional checks as sometimes the term is reset
      //       into a basic format without the dates which then resets the eff date

      const termObject = term?.id ? term : this.termById(term)
      if (termObject) {
        const date = termObject.effectiveStartDate || termObject.startDate
        if (date) this.update(date)
      }
    },
  },
}
